import * as ajax from "../../../actions/ajaxCounterActions";
import * as exception from "../../../actions/exceptionActions";
import financieelApi from "../../../api/financieelApi";
import documentApi from "../../../api/documentApi";
import { getStore } from "../../../store/configureStore";
import * as domainConstants from '../../../constants/DomainConstants';
import showToastr, {showToastrError} from "../../../util/toastr.js";
import { getFileUrl, getFilesForDossierComponent, deleteOneFile } from "../../common/DownloadUploadFilesHelper.js";

export default class FinancieringPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
		this.timer = null;
	}

	init() {
		this.context.setState({
			financiering: null,
			modalIsOpen: false,
			financierId: null,
			documenten: []
		});

		const dossierId = this.context.props.dossierId;
		this.getFinancieringByDossierId(dossierId);
		this.getDocumentenByDossierId(dossierId);
	}

	loadLayout(financieel) {
		const dossierId = this.context.props.dossierId;

		this.context.props.loadLayout(financieel.naam, financieel.tabTitel, dossierId, financieel.typeDossier);
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	goToFinancierEdit() {
		this.redirector.goTo(`financieel/${this.context.props.dossierId}/financieredit/new`);
	}

	handleOnEditFinancier(dossierId, financierId) {
		const urlEdit = `/financieel/${dossierId}/financieredit/edit/${financierId}`;
		this.redirector.goTo(urlEdit);
	}

	getFinancieringByDossierId(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getFinancieringByDossierId(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadBeads(response.data.beadModels);
				this.loadLayout(response.data);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getDocumentenByDossierId(dossierId) {
		this.dispatch(ajax.started());
		documentApi.getContent(dossierId, domainConstants.DocumentTab.MinimaleEisen)
			.then(response => {
				this.dispatch(ajax.ended());

				this.context.setState({
					documenten: response.data
				});

			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});

	}

	getFileUrl(dossierId, financierId, documentnaam) {
		return getFileUrl(dossierId, domainConstants.DocumentTab.FinancieelSubtabFinanciering, "Financier_" + financierId, documentnaam);
	}

	generateRapport() {
		const dossierId = this.context.props.dossierId;
		this.dispatch(ajax.started());
		this.context.setState({
			documenten: []
		});

		financieelApi.generateRapportHaalbaarheid(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				showToastr(domainConstants.PDF_GENEREREN);
				this.handleOnStartInterval();
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	handleOnStartInterval() {
		const dossierId = this.context.props.dossierId;
		this.context.setState({ pollCount: 0 });
		this.timer = setInterval(() => {
			if (this.context.state.pollCount > 19)
				this.handleOnStopInterval();

			documentApi.getContent(dossierId, domainConstants.DocumentTab.MinimaleEisen)
				.then(response => {
					if (response.status == 200) {
						if (getFilesForDossierComponent(domainConstants.ComponentName.HaalbaarheidsRapport, response.data).length > 0) {
							this.context.setState({
								documenten: response.data
							});
							this.handleOnStopInterval();
						}
					}
					this.context.setState({ pollCount: this.context.state.pollCount + 1 });
				})
				.catch(error => {
					this.context.setState({ pollCount: this.context.state.pollCount + 1 });
					this.dispatch(ajax.failed(error));
					return {
						success: false,
						data: error
					};
				});
		}, 20000);

		this.context.setState({ timer: this.timer });
	}

	handleOnStopInterval() {
		clearInterval(this.timer);
		this.context.setState({ timer: null });
	}

	isReadyToRender() {
		if (!this.context.state.financiering) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(item) {
		this.context.setState({
			financiering: item
		});
	}

	deleteFinancier() {
		this.closeModal();
		this.dispatch(ajax.started());
		const state = this.context.state;
		const id = state.financierId;
		financieelApi.deleteFinancier(id)
			.then(response => {
				let financiers = this.context.state.financiering.financiers;
				let newFinanciers = Object.assign({},
					this.context.state.financiering,
					{
						financiers: financiers.filter(k => k.id !== id)
					});
                this.onDeleteFile(id, financiers.find(el => el.id === id));
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(newFinanciers);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});

	}

    onDeleteFile(financierId, financier) {
        if(financier.ulBewijsVanFinanciering.aantal === 0) return;

        const context = this.context;
        const props = context.props;
        const dossierId = props.dossierId;
        const  componentName = financierId ? domainConstants.ComponentName.Financier + '_' + financierId : null;

			props.startFileSession(dossierId, domainConstants.DocumentTab.FinancieelSubtabFinanciering)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({
							fileSessionStarted: true
						});
					}
				}).then(() => {
                    deleteOneFile(context, props.deleteDocument, dossierId, domainConstants.DocumentTab.FinancieelSubtabFinanciering, componentName, financier.ulBewijsVanFinanciering.documenten)
                    .then(() => {
                        props.endFileSession(dossierId, domainConstants.DocumentTab.FinancieelSubtabFinanciering)
                        .then(result => {
                            if (!result.success) {
                                showToastrError(domainConstants.HAS_FILE_EXCEPTION);
                                throw new Error("File process failed"); //Stops promise
                            } else {
                                context.setState({ fileSessionStarted: false });
                            }
                        });
                    });
                });
            }

	closeModal() {
		this.context.setState({
			modalIsOpen: false
		});
	}

	openModal(id) {
		this.context.setState({
			modalIsOpen: true,
			financierId: id
		});
	}
}